module.exports = __webpack_public_path__ + "img/Zycienapodium.8cacb18a.jpg";